import { SignOut } from './SignOut.component';
import { connect } from 'react-redux';

import * as actions from '+/actions';
import * as apiCalls from '+/utils/apiCalls';
import { notifyError } from '+/utils/toastsManager';

const mapDispatchToProps = dispatch => ({
  // Only clear client state when the server confirms the session was
  // destroyed. If the DELETE fails we surface the error via a toast and
  // leave Redux untouched — the user is still signed in on the server,
  // so pretending otherwise on the client would just reproduce the same
  // invisible-inconsistency bug this PR was meant to fix. Returns true
  // on confirmed sign-out, false otherwise, so the component can decide
  // whether to redirect.
  signOutUser: async () => {
    const response = await apiCalls.signOutUser();
    // buildDELETE returns either a result object, { errors: [...] } on
    // an HTTP error, or a raw Error instance on a network failure —
    // treat all three failure shapes the same.
    const failed = !response || response instanceof Error || response.errors;
    if (failed) {
      // eslint-disable-next-line no-console
      console.error('Sign-out failed:', response);
      notifyError(
        response && response.errors
          ? response
          : { errors: ['Unable to sign out. Please try again.'] },
      );
      return false;
    }
    dispatch(actions.signOutUser());
    return true;
  },
});


export default connect(null, mapDispatchToProps)(SignOut);
